import React from 'react'
import PropTypes from 'prop-types'
import { get, kebabCase } from 'lodash-es'
import { imageCss } from '../style'
import { IMAGE_TYPE } from '@/constants/personalization-studio'

function PsImage({ recommendation = {} }) {
  const imageType = get(recommendation, 'content.imageType', {})
  const src = get(recommendation, 'content.image', '')
  const alt = get(recommendation, 'content.imageAccessibilityText', '')
  const height = get(recommendation, 'content.imageHeight', '')
  const width = get(recommendation, 'content.imageWidth', '')

  const { URL } = IMAGE_TYPE

  const imageStyle = {
    ...(height && { height: `${height}px` }),
    ...(width && { width: `${width}px` }),
  }

  switch (imageType) {
    case URL:
      return (
        <div
          data-testid={`ps-image-url-${kebabCase(alt)}`}
          role="img"
          aria-label={alt}
          css={imageCss(src)}
          style={imageStyle}
        />
      )
    default:
      return null
  }
}

PsImage.propTypes = {
  recommendation: PropTypes.object,
}

export default PsImage
